export default __webpack_public_path__ + "static/media/Ordenamiento_Forestal.06c8f383.jpg";